import {Injectable} from '@angular/core';
import {SharedService} from '../../services/shared.service';
import {LocalStorageService} from 'ngx-webstorage';
import {BreakdownCalculations} from './calculations/breakdown-calculations.model';

@Injectable({
  providedIn: 'root'
})
export class BreakdownService {
  constructor(private breakdownCalculations: BreakdownCalculations, private sharedService: SharedService, private sessionSt: LocalStorageService) {
  }

  convertToPolicy(data) {
    return this.sharedService.postAPI('breakdown/quote/convert_to_policy', data);
  }

  // Get All Static Data
  getStaticData(authDetails) {
    return this.sharedService.getAmlineAPI('horsebox-api/lists', authDetails);
  }

  // Get Breakdown Data
  getBreakdownData(id: string) {
    return this.sharedService.getAPI('breakdown/quote/' + id);
  }

  getHorseboxOptions(version: string = '1') {
    return this.sharedService.getAPI('horsebox/options/' + version);
  }

  // Save Indicative Quote
  saveQuote(data) {
    return this.sharedService.postAPI('breakdown/quote', data);
  }

  // Get Quote Details
  getQuoteDetails(id) {
    return this.sharedService.getAPI('breakdown/quote/' + id);
  }

  // Get Quote Details
  getQuoteDetailsByQuoteID(id) {
    return this.sharedService.getAPI('breakdown/quote/' + id);
  }

  getBreakdownQuoteDetailsByQuoteID(id) {
    return this.sharedService.getAPI('breakdown/quote/' + id);
  }

  // GET UNIQUE ID FOR DRIVERS
  getUniqueID(authDetails) {
    return this.sharedService.getAmlineAPI('horsebox-api/generate-id', authDetails);
  }

  public getQuoteDocuments(quote_id, type = 1, is_underwritten = 0) {
    return this.sharedService.getAPI('breakdown/quote/documents/' + quote_id + '/' + type + '/' + is_underwritten);
  }

  /*
  * Create Quote Object for Save API
  */
  createQuoteObj(data) {
    return {
      data: {
        type: 'breakdown/quote',
        attributes: {
          declaration: true,
          proposer: data.proposer,
        },
      }
    };
  }

  /*
  * Issue The Quote
  */
  issueQuote(data) {
    return this.sharedService.postAPI('breakdown/quote/convert_to_policy', data);
  }

  calculateMTAFinancials(data) {
    return this.sharedService.postAPI('breakdown/calculate-mta', data);
  }

  /*
  * Cancel Policy
  */
  getCancelPolicy(data, policyId, authDetails) {
    return this.sharedService.postAPI('breakdown/quote', data);
  }

  getVehicleDetails(registration_number, authDetails) {
    return this.sharedService.getAmlineAPI('horsebox-api/vehicle/' + registration_number, authDetails);
  }

  getAgreedQuestions(productId, agreedQuestionVersion = 1) {
    return this.sharedService.getAPI('staticdata/agreed_questions/' + productId + '/' + agreedQuestionVersion);
  }

  getAccessToken(data) {
    return this.sharedService.postAmlineAPI('oauth/token', data);
  }
}
